export default {
    configuration: false,
    searchList: {
        searchTxt: [
            // {
            //     name: '供应商',
            //     advanceLabel: '供应商',
            //     value: 'carrierName',
            //     advanceConfig: [
            //         { prop: 'supplierNameCn', value: '供应商名称' },
            //         { prop: 'supplierCode', value: '供应商编码' }
            //     ],
            //     tableConfig: [
            //         { prop: 'supplierNameCn', value: '供应商名称' },
            //         { prop: 'supplierCode', value: '供应商编码' }
            //     ],
            //     method: 'post',
            //     prefix: '/api-tms',
            //     advanceUrl: '/srm/supplier/search',
            //     type: 'advance',
            //     advanceNotSearch: true,
            //     queryConditionRequired: true,
            //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode'],
            //     advanceCascade: 'supplierCode#carrierCode',
            //     unfold: true,
            //     span: 4
            // },
            {
                name: '配置状态',
                value: 'configFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '启用', value: 'true' },
                    { label: '停用', value: 'false' }
                ],
                span: 4,
                unfold: true
            },
            {
                name: '配置维度',
                value: 'configType',
                type: 'select',
                optionNum: 'CONFIG_TYPE',
                options: [],
                span: 4,
                unfold: true
            },
            {
                name: '配置创建时间',
                value: 'createTime',
                startTime: 'createTimeStart',
                endTime: 'createTimeEnd',
                startPlaceholder: '配置创建开始日期',
                endPlaceholder: '配置创建结束日期',
                type: 'time',
                unfold: true,
                span: 6
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        height: 400,
        leftWidth: 120,
        selectBtn: true,
        leftOperation: true,
        columns: [
            {
                label: '序号',
                width: 80,
                prop: 'tableIndex',
                sort: true
            },
            {
                label: '供应商编码',
                width: 150,
                prop: 'carrierCode',
                sort: true
            },
            {
                label: '供应商名称',
                width: 150,
                prop: 'carrierName',
                sort: true
            },
            {
                label: '配置状态',
                width: 150,
                prop: 'configFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '启用', value: 'true' },
                    { label: '停用', value: 'false' }
                ],
                sort: true
            },
            {
                label: '配置维度',
                width: 150,
                prop: 'configType',
                type: 'select',
                optionNum: 'CONFIG_TYPE',
                options: [],
                sort: true
            },
            {
                label: '审批状态',
                width: 150,
                prop: 'iflowStatus',
                type: 'select',
                optionNum: 'OTP_APPLY_STATUS',
                options: [],
                sort: true
            },
            {
                label: '创建人',
                width: 150,
                prop: 'createUserName',
                sort: true
            },
            {
                label: '创建时间',
                width: 150,
                prop: 'createTime',
                sort: true
            },
            {
                label: '最近编辑人',
                width: 150,
                prop: 'lastUpdateUserName',
                sort: true
            },
            {
                label: '最近编辑时间',
                width: 150,
                prop: 'lastUpdateTime',
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit',
                ifHas: 'driver-payment-duration-config-detail'
            },
            {
                type: 'text',
                label: '编辑记录',
                size: 'small',
                event: 'editRecord',
                ifHas: 'driver-payment-duration-config-editLog'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: []
};
